import type { PublicNavContext } from "../publicNavigation";
import type { NavConfig, NavItem } from "./types";

export function getSolutionsNavConfig(
  ctx: PublicNavContext,
): NavConfig["solutions"] {
  const { isSwedish } = ctx;
  return (() => {
    const items: NavItem[] = [
      {
        label: isSwedish ? "Privata utförare" : "Private providers",
        href: isSwedish
          ? "/losningar/privat-hemtjanst"
          : "/en/solutions/private-home-care",
        description: isSwedish
          ? "För privata utförare av hemtjänst"
          : "For private home-care providers",
      },
      {
        label: isSwedish ? "Hemtjänstkedjor" : "Home-care chains",
        href: isSwedish
          ? "/losningar/hemtjanstkedja"
          : "/en/solutions/home-care-chain",
        description: isSwedish
          ? "Marginal utan att skära i omsorgen"
          : "Margin without cutting care",
      },
      {
        label: isSwedish ? "Kommuner" : "Municipalities",
        href: isSwedish
          ? "/losningar/kommuner"
          : "/en/solutions/municipalities",
        description: isSwedish
          ? "Uppföljning i egen regi och hos utförare"
          : "Follow-up in-house and at providers",
      },
      {
        label: isSwedish ? "Verksamhetschefer" : "Operations managers",
        href: isSwedish
          ? "/losningar/verksamhetschef"
          : "/en/solutions/operations-manager",
        description: isSwedish
          ? "Jämnare arbetsdagar för personalen"
          : "More even workdays for staff",
      },
      {
        label: isSwedish ? "Planerare" : "Planners",
        href: isSwedish ? "/losningar/samordnare" : "/en/solutions/scheduler",
        description: isSwedish
          ? "Timmar av pusslande försvinner"
          : "Hours of puzzling disappear",
      },
    ];
    const href = isSwedish ? "/losningar" : "/en/solutions";

    return {
      label: isSwedish ? "Lösningar" : "Solutions",
      href,
      items,
      submenu: {
        overview: {
          label: isSwedish ? "Alla lösningar" : "All solutions",
          href,
          description: isSwedish
            ? "Vad Caire ger er, beroende på var ni sitter"
            : "What Caire gives you, depending on where you sit",
        },
        items,
        groups: [],
      },
    };
  })();
}
